import { render } from "./AdminYellowRequest.vue?vue&type=template&id=2d1ab08a"
import script from "./AdminYellowRequest.vue?vue&type=script&lang=js"
export * from "./AdminYellowRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__